import React from 'react';
import classNames from 'classnames';

const Tab = ({ disabled = false, selected = false, label, onClick }) => {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onClick();
    }
  };

  const classes = classNames('ws-ui-tab-selector__tab', {
    'ws-ui-tab-selector__tab--selected': selected,
  });

  return (
    <button
      className={classes}
      disabled={disabled}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      type="button"
    >
      {label}
    </button>
  );
};

export default Tab;
